<div class="row vh-100" [hidden]="isAppDownloadActive">
     <div class="col-lg-6 col-md-12 p-3 onboarding-banner-section">
        <app-onboarding-banner [currentStep]="currentStep"></app-onboarding-banner>
    </div> 
    <div class="col-lg-6 col-md-12 p-3">
        <div class="onboarding-container">
            <div class="onboarding">
                <div class="logo-container">
                    <a href="https://www.expenseondemand.com/">
                        <img src="../../assets/images/logo.svg"
                            alt="Expense On Demand" width="140px" />
                    </a>
                </div>
                @if(isLoginActive){<app-login-new (gotoNextStepEvent)="onLoginClick($event)"></app-login-new>}
                @if(isSignupActive){<app-register (gotoNextStepEvent)="gotoNextStep($event)" (gotoLoginEvent)="gotoLogin()"></app-register>}
                @if(isOTPVerificationActive){<app-otp-verification (gotoNextStepEvent)="gotoNextStep($event)"></app-otp-verification>}
                @if(isCreatePasswordActive){<app-create-password  (gotoNextStepEvent)="gotoNextStep($event)"></app-create-password>}
                @if(isOrgDetailActive){<app-organisation-details (gotoNextStepEvent)="gotoNextStep($event)"></app-organisation-details>}
                @if(isInviteEmployeeActive){<app-invite-employees (gotoNextStepEvent)="gotoNextStep($event)"></app-invite-employees>}
            </div>
            <div class="one-col-grid align-items-center gap-0">
                <p class="copyright-text">{{'copyright_expense_on_demand' | translate}}</p>
                <p class="copyright-text">{{'do_not_store_credit_card_details' | translate}}</p>
            </div>
        </div>
    </div>
</div>
@if(isAppDownloadActive){<app-app-download></app-app-download>}
